import { render, staticRenderFns } from "./ConfigurarTerminal.vue?vue&type=template&id=70572d98&scoped=true"
import script from "./ConfigurarTerminal.vue?vue&type=script&lang=js"
export * from "./ConfigurarTerminal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarTerminal.vue?vue&type=style&index=0&id=70572d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70572d98",
  null
  
)

export default component.exports